// @ts-nocheck
import { makeStyles, Box } from "@material-ui/core";
import { EmptyState } from "../../../../common/components";
import HouseholdDeviceCard from "./HouseholdDeviceCard";
import { useTranslation } from "react-i18next";
import { Action, Household } from "../../types";

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
  },
}));

function HouseholdDevices({ household, handleAction, actionsDisabled }:
    { household: Household; handleAction: (action: Action) => void; actionsDisabled: boolean }) {
    const classes = useStyles();
    const [t] = useTranslation();

    return (
      <Box className={classes.container}>
        {household.devices?.length ? (
          <Box mt={3}>
            {household.devices.map(device => (
              <HouseholdDeviceCard key={device.id} device={device} onAction={handleAction} />
            ))}
          </Box>
        ) : (
          <EmptyState message={t('household.householdDevicesNotAvailable')} />
        )}
      </Box>
  );
}

export default HouseholdDevices;